
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	import Dialog from '@/components/dialog.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		getAgentCheckOrderList
	} from '@/api/order'
	import {
		nextDay
	} from "@/utils"

	@Component({
		name: 'sku-list-dialog',
		components: {
			'slz-dialog': Dialog,
			PickerDate
		}
	})
	export default class SkuListDialog extends Vue {

		@Model('change') isShow!: boolean;
		@Prop({}) private id!: number;
		@Prop({}) private time:any

		private showDialog = false;

		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private orderlist: any = [];
		private keywords = '';

		private radioType = 1;
		private radioList: any = [{
			label: '已通过',
			value: 1
		}, {
			label: '已驳回',
			value: 2
		}];
		private filterTime: any = '';
		private filterCheckTime: any = '';
		private selectTime = 0;
		private selectTimes = [{
			label: '下单时间',
			value: 0
		}]
		private checkTime = 0;
		private checkTimes = [{
			label: '审核时间',
			value: 0
		}]


		@Watch('isShow')
		private onChangeShow(val) {
			this.showDialog = val
			if (val) {
				this.filterTime = this.time.ordertime
				this.filterCheckTime = this.time.audittime
				this.getList();
			}
		}
		
		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}
		
		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		// 关闭
		private handleClose() {
			this.radioType = 1
			this.keywords = ''
			this.pageNo = 1
			this.filterTime = null
			this.filterCheckTime = null
			this.showDialog = false;
			this.$emit('change', false)
		}

		private async getList() {
			
			let times: any = '';
			if (this.filterTime){
				times = this.filterTime.split('/');
			}
			
			let checkTimes: any = '';
			if (this.filterCheckTime){
				checkTimes = this.filterCheckTime.split('/');
			}
			
			let params: any = {
				MemberId: +this.id,
				CheckState: +this.radioType,
				Keywords: this.keywords,
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				AddStartTime: times ? times[0]:'',
				AddEndTime: times ? nextDay(times[1],1):'',
				CheckStartTime: checkTimes ? checkTimes[0]:'',
				CheckEndTime: checkTimes ? nextDay(checkTimes[1],1):'',
			}
			
			try {
				const res: any = await getAgentCheckOrderList(params);
				this.list = res.Result.Results || [];
				this.total = res.Result.Total
			} catch (e) {
				console.log(e)
			}
		}
	}
